import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logoImg from "../assets/rhcwf-logo.jpeg";
import api from "../services/api";
export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const login = async () => {
    if (!form.email || !form.password) {
      alert("Please enter email and password");
      return;
    }

    setLoading(true);
    try {
      console.log("Sending login request:", form.email);

      const res = await api.post(
  "/auth/login",
        form,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      console.log("Login response:", res.data);
      
      const { token, role, userId, userName, gpId } = res.data;

      // Store in localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("userId", userId);
      localStorage.setItem("userName", userName);
      localStorage.setItem("userGpId", gpId || "");
      localStorage.setItem("LOGGED_USER", form.email);
      localStorage.setItem("userRole", role);

      // Store in sessionStorage (backup)
      sessionStorage.setItem("userId", userId);
      sessionStorage.setItem("userRole", role);
      sessionStorage.setItem("userName", userName);

      // Redirect based on role
      if (role === "ADMIN") {
        navigate("/dashboard");
      } else if (role === "GP_COORDINATOR") {
        navigate("/gp-dashboard");
      } else if (role === "DISTRICT_COORDINATOR") {
        navigate("/district-dashboard");
      } else if (role === "BLOCK_COORDINATOR") {
        navigate("/block-dashboard");
        
      
      } else if (role === "STATE_COORDINATOR") {
        navigate("/state-dashboard");
        
      } else {
        navigate("/profile");
      }

    } catch (err) {
      console.error("Login error:", err);
      const errorMessage = err.response?.data?.message || err.response?.data || "Login failed. Please check your credentials.";
      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      login();
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.box}>
        <div style={styles.logoContainer}>
          <div style={styles.circularLogo}>
            <img src={logoImg} alt="RHCWF Logo" style={styles.logoImage} />
          </div>
          <h2 style={styles.title}>Re-connecting HealthCare And Welfare Foundation (NG0)</h2>
          
          <div style={styles.estdBadge}>ESTD: 2026</div>
        </div>

        <div style={styles.formContainer}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Email Address</label>
            <input
              name="email"
              type="email"
              placeholder="admin@example.com"
              value={form.email}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
              style={styles.input}
              autoComplete="off"
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Password</label>
            <div style={styles.passwordWrapper}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Enter your password"
                value={form.password}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                style={styles.input}
                autoComplete="off"
              />
              <button
                type="button"
                style={styles.passwordToggle}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "👁️" : "👁️‍🗨️"}
              </button>
            </div>
          </div>

          <button 
            onClick={login} 
            style={loading ? {...styles.btn, ...styles.btnDisabled} : styles.btn}
            disabled={loading}
          >
            {loading ? (
              <span style={styles.loadingSpinner}>⏳</span>
            ) : (
              "Login"
            )}
          </button>
        </div>

        <div style={styles.footer}>
          <p>© 2026 Reconnecting Health Care And Welfare Foundation</p>
          <p style={styles.helpText}>Need help? Contact support</p>
        </div>
      </div>
    </div>
  );
}

// Modern Styles
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    padding: "20px",
  },
  box: {
    padding: "40px",
    background: "white",
    borderRadius: "24px",
    width: "100%",
    maxWidth: "440px",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    textAlign: "center",
    transition: "transform 0.3s ease",
  },
  logoContainer: {
    marginBottom: "30px",
  },
  circularLogo: {
    width: "100px",
    height: "100px",
    margin: "0 auto 20px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "3px solid #667eea",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
  },
  logoImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  title: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1E293B",
    marginBottom: "8px",
    letterSpacing: "-0.3px",
    lineHeight: "1.3",
  },
  subtitle: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#64748B",
    marginTop: "0",
    marginBottom: "10px",
  },
  estdBadge: {
    display: "inline-block",
    background: "#F1F5F9",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "10px",
    fontWeight: "600",
    color: "#667eea",
    marginTop: "5px",
  },
  formContainer: {
    marginTop: "25px",
  },
  inputGroup: {
    marginBottom: "20px",
    textAlign: "left",
  },
  label: {
    display: "block",
    fontSize: "12px",
    fontWeight: "600",
    color: "#475569",
    marginBottom: "6px",
    letterSpacing: "0.3px",
  },
  input: {
    width: "100%",
    padding: "12px 15px",
    border: "1.5px solid #E2E8F0",
    borderRadius: "12px",
    fontSize: "14px",
    transition: "all 0.2s ease",
    boxSizing: "border-box",
    outline: "none",
    fontFamily: "inherit",
  },
  inputFocus: {
    borderColor: "#667eea",
    boxShadow: "0 0 0 3px rgba(102, 126, 234, 0.1)",
  },
  passwordWrapper: {
    position: "relative",
  },
  passwordToggle: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    padding: "0",
    color: "#94A3B8",
  },
  btn: {
    width: "100%",
    padding: "12px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    border: "none",
    borderRadius: "12px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginTop: "10px",
  },
  btnDisabled: {
    opacity: 0.7,
    cursor: "not-allowed",
  },
  loadingSpinner: {
    display: "inline-block",
    animation: "spin 1s linear infinite",
  },
  footer: {
    marginTop: "30px",
    fontSize: "10px",
    color: "#94A3B8",
  },
  helpText: {
    marginTop: "8px",
    fontSize: "10px",
    color: "#94A3B8",
    cursor: "pointer",
  },
};

// Add this to your global CSS or component
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  input:focus {
    border-color: #667eea !important;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
  }
  
  button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px -5px rgba(102, 126, 234, 0.4);
  }
`;
document.head.appendChild(styleSheet);